/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgMailing48(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={48}
      height={48}
      fill='none'
      viewBox='0 0 48 48'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M0 7h48L30.77 22.93l11.995 12.422-1.303 1.258L29.44 24.16l-3.291 3.042c-1.166 1.065-3.122 1.074-4.298 0l-3.291-3.043L6.538 36.61l-1.303-1.258L17.23 22.93 1.959 8.811H1.81v30.793H46.19L46 8.86 48 7v34.415H0V7zm43.373 1.811H4.627c6.164 5.699 12.157 11.587 18.491 17.094a1.398 1.398 0 001.788-.021L43.373 8.81z'
      />
    </svg>
  );
}

export default SvgMailing48;
